import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ObtenerNumeroMcpServersService } from '../../../../application/administrador/services/obtener-numero-mcp-servers.service';

@Component({
  selector: 'app-gestion-integraciones-resumen',
  templateUrl: './gestion-integraciones-resumen.component.html',
  styleUrl: './gestion-integraciones-resumen.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GestionIntegracionesResumenComponent implements OnInit {
  numeroMcpServers: number = 0;
  cargando: boolean = true;

  constructor(
    private readonly obtenerNumeroMcpServersService: ObtenerNumeroMcpServersService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.obtenerNumeroMcpServers().subscribe({
      next: (mcpServers) => {
        this.numeroMcpServers = mcpServers;
      },
      error: (error) => {
        this.toastrService.error(
          'Error al cargar la información sobre las integraciones',
        );
        this.cargando = false;
      },
      complete: () => {
        this.cargando = false;
      },
    });
  }

  public obtenerNumeroMcpServers(): Observable<number> {
    return this.obtenerNumeroMcpServersService.__invoke();
  }
}
